import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      listTemplatesReports: [],
      selectedTemplateReport: null,
      selectedTemplateReportData: null,
      onlyEmailReport: false,
    }
  },
  computed: {
    ...mapGetters('analytics', {
      getSavedReports: 'getSavedReports',
      getSavedReportById: 'getSavedReportById'
    }),
    listReportsFiltered() {
      return [...this.listTemplatesReports].sort((a, b) => (a.id < b.id ? 1 : -1))
    }
  },
  methods: {
    ...mapActions('analytics', ['fetchSavedReports']),

    async initSavedReports() {
      if (!this.getSavedReports || this.getSavedReports.length === 0) {
        await this.fetchSavedReports()
      }

      this.listTemplatesReports = [...this.getSavedReports].sort((a, b) => (a.id < b.id ? 1 : -1))

      if (this.savedReportId) {
        this.selectedTemplateReport = this.savedReportId
        this.isSavedReport = true
        await this.loadSavedReportData(this.isInitialLoad)
      }

      this.isInitialLoad = false
    },

    async onSelectTemplate(selected) {
      this.selectedTemplateReport = selected
      await this.loadSavedReportData()
    },

    async loadSavedReportData(isInitialLoad = false) {
      const data = this.getSavedReportById(this.selectedTemplateReport)
      this.selectedTemplateReportData = { ...data }

      // Reset all fields before loading new data
      if (!isInitialLoad) {
        this.resetFields()
      }

      // Load data into fields
      this.newReportName = data.name
      this.selectedCampaignSource = data.campaign_source === 'PadSquad' ? data.campaign_source : 'Airtory Sync'

      this.selectedCampaignsIds = data.all_campaigns_selected ? [0] : this.getArrayFromString(data.campaigns, true)
      this.selectedPlacements = this.getArrayFromString(data.placements, true)
      this.selectedCreatives = this.getArrayFromString(data.creatives, true)

      this.loadMetrics(data.metrics)
      this.loadDimensions(data.dimensions)

      this.showRatesAsDecimals = data.rates_as_decimals
      this.emails = data.emails.split(',').map((email, index) => ({ index, value: email.trim() }))
      this.selectedDateRange = data.date_range
      this.dateRangeData.startDate = moment.utc(data.startDate).toDate()
      this.dateRangeData.endDate = moment.utc(data.endDate).toDate()
      this.schedule.frequencySelected = data.frequency || 'No Schedule'
      this.schedule.daySelected = data.day || null
      this.schedule.hourSelected = this.getHourSelected(data.hour)
      this.onlyEmailReport = data.only_email || false
      this.selectedOrderBy = data.sort_by

      if (this.selectedCampaignsIds.length === 1 && this.selectedCampaignsIds[0] !== 0) {
        await this.loadCampaignData(false)
      } else {
        this.setDefaultPlacementsAndCreatives()
      }

      // After loading, update any dependent data
      this.onSelectCampaignChange(this.selectedCampaignsIds)
      this.onSelectDateRange(this.selectedDateRange)
    },
    getHourSelected(hour) {
      return hour ? this.hours.find(item => item.utc0to23 === parseInt(hour))?.hour || null : null
    },
    setDefaultPlacementsAndCreatives() {
      this.selectedCampaignsPlacements = [{ id: 0, name: 'All Placements' }]
      this.selectedCampaignsCreatives = [{ id: 0, name: 'All Creatives' }]
      this.selectedPlacements = [0]
      this.selectedCreatives = [0]
    },
    getArrayFromString(string, parse = false) {
      if (parse) return string.split(',').map(item => parseInt(item)) || [0]
      return string.split(',').map(item => item)
    }
  }
}
